import React from 'react';
import styled from '@emotion/styled';

import { Gray_Light_700, TextAlign, Typography } from '@common/styles';

import { Drawer, DrawerProps } from './Drawer';

export interface HelpDrawerProps extends DrawerProps {
  title: string;
  title_align?: TextAlign;
}

export const HelpDrawer: React.FC<React.PropsWithChildren<HelpDrawerProps>> = ({ title, title_align, children, ...otherProps }) => {
  return (
    <Drawer height='auto' {...otherProps}>
      <Container>
        <Title className={Typography.HEAD_20_BOLD} $align={title_align}>
          {title}
        </Title>
        <Content className={Typography.BODY_14_REGULAR}>{children}</Content>
      </Container>
    </Drawer>
  );
};

const Container = styled.div`
  padding: 48px 24px 40px;
  letter-spacing: normal;
`;
const Title = styled.h3<{ $align?: TextAlign }>`
  ${({ $align }) => $align && `text-align: ${$align};`}
`;

const Content = styled.div`
  margin: 12px 0 0;
  line-height: 16px;
  color: ${Gray_Light_700};

  > p {
    margin: 0 0 24px;

    &:last-of-type {
      margin: 0;
    }

    > span {
      display: block;
      margin: 0 0 8px;
    }
  }

  & ul {
    list-style: disc;
    padding-left: 16px;
  }
`;
